/**
 * Sales View design tokens. Mirrors `clientViewTokens.ts` so the two tabs read as
 * one product.
 */
import type { SalesTier } from '../../api/types';

/** Tier palette. Deliberately the severity ramp Broker View uses (red / amber /
 *  blue / slate) rather than Client View's status hues, because tier here is a
 *  severity scale, not a category. */
export const TIER_COLOR: Record<SalesTier, { bg: string; fg: string; pin: string }> = {
  URGENT: { bg: '#fee2e2', fg: '#b91c1c', pin: '#dc2626' },
  HIGH:   { bg: '#fef3c7', fg: '#a16207', pin: '#d97706' },
  MEDIUM: { bg: '#dbeafe', fg: '#1d4ed8', pin: '#2563eb' },
  LOW:    { bg: '#e5e7eb', fg: '#4b5563', pin: '#6b7280' },
};

export const TIER_ORDER: SalesTier[] = ['URGENT', 'HIGH', 'MEDIUM', 'LOW'];

export function tierFromIndex(index: number): SalesTier {
  return TIER_ORDER[index] ?? 'LOW';
}

/** Engagement bands, worst first, so the filter reads like the risk it describes. */
export const ENGAGEMENT_COLOR: Record<string, string> = {
  'At Risk - 60+ Days': '#b91c1c',
  'Lapsing - 30-60 Days': '#a16207',
  'Recent - Last 30 Days': '#1d4ed8',
  'Active - This Week': '#15803d',
};

/** Reason groups carry no fixed palette: the vocabulary is extended at score
 *  v1.5, so a hard-coded map would leave new groups unstyled. */
export const NEUTRAL_DOT = '#6b7280';

/** Green for every opportunity, whatever the code: these are the only signals on
 *  the board that are good news, and the point is that they read differently from
 *  the tier and reason rows at a glance. */
export const OPPORTUNITY_DOT = '#15803d';
/** CSE-17 leader targets: the same purple as the card's Target pill. */
export const TARGET_COLOR = '#5b21b6';
